
<template lang="html">
  <div class="scroll pc">
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="(item, index) in mainProduce" :key="index">
        <img :src="item.bakImg" alt="" class="pc">
        <div class="">
          <div class="">
            <div class="">
              <h1>{{item.title}}</h1>
              <p>{{item.intro}}</p>
            </div>
            <div class="btn-box flex-reverse">
              <div class="img-box">
                <img v-if="item.qrImg" :src="item.qrImg" alt="" @click.stop="previewQr(item.qrImg)">
                <p v-if="!item.qrImg">维护中...</p>
              </div>
              <div class="">
                <ul>
                  <li v-for="(inItem, inIndex) in item.typeCt" :key="inIndex">
                    <button type="button" name="button" @click.stop="toOpr(inItem)">{{inItem.name}}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right-img" :class="{'exh': index === 0}">
            <img :src="item.contentImg" alt="">
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide>
        <img src="~common/pc/images/banner_background_02.png" alt="" class="pc">
        <div class="">
          <div class="">
            <div class="">
              <h1>福音广告</h1>
              <p>——报福音、传喜信的人，他们的脚踪何等佳美</p>
            </div>
            <div class="btn-box">
              <div class="self-end">
                <ul>
                  <li>
                    <button type="button" name="button">联系我们</button>
                  </li>
                </ul>
              </div>
              <div class="img-box">
                <img src="" alt="">
                <p>维护中...</p>
              </div>
            </div>
          </div>
          <div class="adv right-img">
            <img src="~common/pc/images/advertisement0.png" alt="">
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <img src="~common/pc/images/banner_background_03.png" alt="" class="pc">
        <div class="">
          <div class="">
            <div class="">
              <h1>恩典365</h1>
              <p>365天，一起活着神的爱和恩典里面</p>
            </div>
            <div class="btn-box flex-reverse">
              <div class="img-box">
                <img src="~common/pc/images/qr-365.png" alt="">
              </div>
              <div class="">
                <ul>
                  <li>
                    <button type="button" name="button">Android端</button>
                  </li>
                  <li>
                    <button type="button" name="button">IOS端</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right-img">
            <img src="~common/pc/images/grace_365.png" alt="">
          </div>
        </div>
      </swiper-slide> -->
      <!-- Optional controls -->
      <div class="swiper-pagination "  slot="pagination"></div>
    </swiper>
    <div class="main">
      <div class="top">
        <h1>产品动态</h1>
        <span class="pc">PRODUCT DYNAMICS</span>
      </div>
      <div class="main-content" v-for="(item, index) in produceActive" :key="index" :class="{'reverse': index === 1, 'pb20': index === 1}">
        <div class="content-imgbox">
          <img v-lazy="item.img" alt="" class="pc">
        </div>
        <div class="detail" :class="{'lf': index === 0, 'rt': index === 1}">
          <div class="top-in">
            <h1>{{item.title}}</h1>
            <div class="more" @click="toMore(item.more)" v-if="item.more">
              更多
              <i class="icon iconfont icon-gengduo1"></i>
            </div>
          </div>
          <div class="">
            <ul>
              <li v-for="(inItem, inIndex) in item.content" :key="inIndex">{{inItem.item}}<span>{{inItem.date}}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="main-content reverse pb20">
        <div class="content-imgbox">
          <img src="~common/pc/images/second_product.png" alt="" class="pc">
        </div>
        <div class="detail rt">
          <div class="top-in">
            <h1>福音广告</h1>
            <div class="more">
              更多
              <i class="icon iconfont icon-gengduo1"></i>
            </div>
          </div>
          <div class="">
            <ul>
              <li>福音广告二期跟进端公测           <span>2019-05-13</span></li>
              <li>福音广告一期发布上线了             <span>2019-04-25</span></li>
              <li>线下活动完美收官            <span>2019-04-17</span></li>
              <li>福音广告一期公测开始了~~         <span>2019-04-01</span></li>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import produceData from 'common/pc/js/produce'
import 'swiper/dist/css/swiper.css'
import 'common/pc/stylus/base.styl'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {mapGetters, mapMutations} from 'vuex'
export default {
  data () {
    return {
      produceActive: null,
      mainProduce: null,
      fyShow: false,
      swiperOption: {
        notNextTick: true, // 循环
        loop: true, // 设定初始化时slide的索引
        initialSlide: 0, // 自动播放
        autoplay: true,
        // autoplay: {
        //     delay: 3000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true,
        // },
        // 设置轮播
        // effect: 'flip',
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: 'horizontal',
        // 小手掌抓取滑动
        // grabCursor : true,
        // 滑动之后回调函数
        // on: {
        //   slideChangeTransitionEnd: function () {
        //     // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
        //   }
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // 分页器设置
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  created () {
    this.mainProduce = produceData.mainProduce
    this.produceActive = produceData.produceActive
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...mapGetters(['isShow']),
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    // 二维码预览
    previewQr (url) {
      this.setImg(url)
      this.preview(true)
    },
    //
    toOpr (item) {
      console.log(item)
      if (!item.img && !item.link) {
        return false
      }
      if (!item.link) {
        this.setImg(item.img)
        this.preview(true)
      } else {
        this.reading(item.link)
      }
    },
    // 更多
    toMore (url) {
      window.open(url)
    },
    // 在线阅读
    reading (url) {
      window.open(url)
    },
    ...mapMutations({
      preview: 'SET_IS_SHOW',
      setImg: 'SET_IMG_URL'
    })
  },
  mounted () {
    console.log('this is current swiper instance object', this.swiper)
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.flex-reverse
  flex-direction: row-reverse
.swiper-slide
  &>img
    width: 100%
    min-height: 513px
  &>div
    width: 1260px
    height: 470px
    position: absolute
    left: 50%
    top: 50%
    display: flex
    justify-content: space-between
    align-items: center
    margin-left: -630px
    margin-top: -235px
    h1
      font-size: 36px
      color: #fff
    p
      font-size: 22px
      color: #fff
      margin: 15px 0 35px
    .btn-box
      display: flex
      align-items: center
      .img-box
        width: 218px
        height: 218px
        position: relative
        background-color: rgba(255, 255, 255, .3)
        margin-left: 60px
        padding: 15px
        p
          width: 100%
          height: 100%
          position: absolute
          left: 0
          top: 0
          right: 0
          bottom: 0
          font-size: 30px
          display: flex
          justify-content: center
          align-items: center
          margin: 0
          color: #fff
        img
          width: 188px
          height: 188px
          position: relative
          cursor: pointer
    .right-img img
      height: 360px
    .exh img
      height: 370px
    button
      width: 200px
      height: 66px
      border-radius: 66px
      overflow: hidden
      background-color: rgba(255, 255, 255, 0.8)
      color: #007CE5
      font-size: 20px
      cursor: pointer
      margin-bottom: 16px
.main
  width: 1400px
  margin: auto
  padding-top: 50px
  .main-content
    display: flex
    justify-content: space-between
    padding-bottom: 50px
    img
      width: 600px
      height: 360px
  .reverse
    flex-direction: row-reverse
  .top
    position: relative
    padding-left: 20px
    margin-bottom: 15px
    h1
      margin-bottom: 5px
      color: #007CE5
    span
      color: #eee
      font-size: 18px
    &:after
      content: ''
      width: 10px
      height: 22px
      position: absolute
      left: 0
      top: 3px
      background-color: #007CE5
  .detail
    flex: 1
    .top-in
      display: flex
      justify-content: space-between
      align-items: center
      padding-bottom: 20px
      div
        cursor: pointer
        font-size: 16px
        color: #007CE5
        i
          color: #007CE5
          font-size: 15px
    li
      position: relative
      display: flex
      justify-content: space-between
      align-items: center
      color: #333
      font-size: 18px
      padding: 46px 0 13px
      line-height: 1
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      border-bottom: 1px dashed #999
      span
        color: #999
      /* &:after
        content: ''
        width: 100%
        height: 1px
        position: absolute
        left: 0
        bottom: 0
        background-color: #999 */
  .lf
    width: calc(100% - 600px)
    padding-left: 50px
  .rt
    padding-right: 50px
.self-end
  align-self: flex-end !important
</style>



// WEBPACK FOOTER //
// src/components/pc/produce/produce.vue